import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [firstName, setFirstName] = useState(null); // 👈 hinzufügen
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    const savedUserId = localStorage.getItem("userId");
    const savedFirstName = localStorage.getItem("firstName"); // 👈 laden
    const savedMustChange = localStorage.getItem("mustChangePassword");

    if (savedToken && savedUserId) {
      setToken(savedToken);
      setUserId(parseInt(savedUserId, 10));
      setFirstName(savedFirstName); // 👈 setzen
      setMustChangePassword(savedMustChange === "true");
    }
  }, []);

  const login = (token, userId, mustChangePassword = false, firstName = "") => {
    const numericUserId = parseInt(userId, 10);
    localStorage.setItem("token", token);
    localStorage.setItem("userId", numericUserId);
    localStorage.setItem("mustChangePassword", mustChangePassword);
    localStorage.setItem("firstName", firstName); // 👈 speichern

    setToken(token);
    setUserId(numericUserId);
    setFirstName(firstName); // 👈 setzen
    setMustChangePassword(mustChangePassword);
  };

  const loginAsDemoUser = () => {
    const demoUserId = 999;
    const demoName = "Demo";
    localStorage.setItem("userId", demoUserId);
    localStorage.setItem("firstName", demoName);
    setUserId(demoUserId);
    setFirstName(demoName);
    setToken(null); // oder ein Dummy-Token?
    setMustChangePassword(false);
  };

  const logout = () => {
    localStorage.clear();
    setToken(null);
    setUserId(null);
    setFirstName(null);
    setMustChangePassword(false);
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        userId,
        firstName,
        login,
        loginAsDemoUser,
        logout,
        mustChangePassword,
        setMustChangePassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
